import $ from 'jquery'
import _ from 'lodash'
import * as Canvas from 'canvas'

import appDisplay from 'scoreboard/components/app-display'

import CanvasContainerView from '../canvas-container-view'

const ViewOnlyCanvasContainerView = CanvasContainerView.extend({
	events: {
		'mouseover': 'onMouseover',
		'click': 'onClick'
	},

	initialize: function (options) {
		CanvasContainerView.prototype.initialize.apply(this, arguments)
		this.embeddedToken = options.embeddedToken
		this.canvasConstructor = options.canvasConstructor
	},

	render () {
		CanvasContainerView.prototype.render.apply(this, arguments)
	},

	onMouseover () {
		// Selects are dismissed on document mouseclick and their events are
		// caught and handled there in before they can be handled here. For that reason
		// and also to handle cases where new selects are created inside an already
		// rendered widget, detect open menu's here.
		//
		// If there's a select menu, set this.selectMenuVisible so that we'll
		// know to suppress any canvas clicks so they don't cause a zoom #38540
		if ($('.select-menu').length > 0) {
			this.selectMenuVisible = true
		}
	},

	onClick (e) {
		// When the canvas is clicked, if a select menu is visible or if there's a
		// tooltip visible, prevent the canvas from zooming.
		// Note that this is only necessary for the Overview, because we don't
		// zoom in the Edit tab
		if (this.selectMenuVisible || $('.tooltip').length > 0) {
			e.stopImmediatePropagation()
			// We've stopped event propagation so tooltips wont get to close.
			// So, trigger a window resize event to make sure they close.
			window.dispatchEvent(new Event('resize'))
			delete this.selectMenuVisible
		}
	},

	createCanvas () {
		// FullscreenCanvas makes sure the entire canvas fits into
		// its container (no scrollbars)
		var options = {
			collection: this.wobs,
			minHeight: this.options.minHeight,
			minWidth: this.options.minWidth
		}

		if (!_.isNil(this.options.padding)) {
			options.padding = this.options.padding
		}

		let canvas = new this.options.canvasConstructor(options)
		canvas.use(Canvas.features.edges)

		canvas.embeddedToken = this.embeddedToken

		canvas.on('ready', () => {
			this.canvasReady = true
			var prevView = appDisplay._display.viewHistory[1]
			if (prevView && (_.endsWith(prevView, 'dashboards-edit.js')
				|| _.endsWith(prevView, 'strategy-maps-edit-view.js'))) {

				canvas.highlightLetterbox()
			}

			if (this.wobs.length === 0) {
				// The 'exportReady' listener below fires after each widget is ready
				// for export, and calls allWobsReady() when they are all ready.
				// But if there are no widgets, it will never be called. In that
				// scenario, just call allWobReady() when canvas says it's ready
				allWobsReady()
			}

			this.checkExportReadyCondition()
		})

		canvas.on('resize zoom', function () {
			// See #18372 - We want the canvas edges border and corners to not be scaled so they match the rest
			// of the app's design.
			// Determine the scale factor of the canvas, and apply the inverse to the border radius and outline
			let scale = this.el.getBoundingClientRect().width / this.el.offsetWidth
			let inverse = 1 / scale

			this.$('.wobs .canvas-edges').css({
				'border-radius': inverse * borderRadiusLarge,
				'border-width': inverse
			})
		})

		// Being ready for display and ready for export are different for some widgets. For example, reports are ready for
		// display while the results are being retrieved, but not ready for export until the results are rendered.
		// So we don't emit the 'exportReady' event on the main dashboard view until all widgets emit 'exportReady'.
		const allWobsReady = () => {
			this.stopListening(canvas, 'exportReady')
			this.exportReady = true
			this.checkExportReadyCondition()
		}
		const pendingWobs = _.keyBy(this.wobs.models, 'id')
		this.listenTo(canvas, 'exportReady', wob => {
			delete pendingWobs[wob.id]
			if (_.isEmpty(pendingWobs)) {
				allWobsReady()
			}
		})

		return canvas
	},

	checkExportReadyCondition() {
		// While investigating #33599 it was found that the ready events were being
		// emitted before the wobs were visible.  We need to wait for BOTH the canvas
		// to be ready (visible) and each wob to report it's own ready state.
		// THEN, we need to emit in a nextTick so it gives everything a chance to paint
		if (this.canvasReady && this.exportReady) {
			process.nextTick(() => this.trigger('exportReady'))
		}
	}
})

// This matches measurements.scss. This would be the default for the canvas-edges if it wasn't scaled.
const borderRadiusLarge = 6

export default ViewOnlyCanvasContainerView

ViewOnlyCanvasContainerView.__filename__ = 'dashboards/display/view-only-canvas-container-view.js'
